<script lang="ts" setup>
import { ProjectAvatar } from '@forgd/ui-kit/blocks/avatars'
import { Button } from '@forgd/ui-kit/button'
import { ArrowLeftIcon } from '@heroicons/vue/24/outline'

useHead({
  title: 'RFQ Details',
})

const route = useRoute()
const rfqId = computed(() => route.params.rfqId as string)

const backButtonUrl = ref('/')

const { data: details } = useQuery({
  ...buildApiQuery('/rfq/mm/rfq-details', {
    params: () => ({
      query: {
        id: rfqId.value,
      },
    }),
  }),
  enabled: () => Boolean(rfqId.value),
  refetchOnWindowFocus: false,
})

const { model: preferencesOpen } = useAppSlideover('rfq-preferences')

watch(() => route.params.rfqId, (val, oldVal) => {
  const comeFromRfqsListPage = val && val !== oldVal
  backButtonUrl.value = '/'
  if (comeFromRfqsListPage && typeof window !== 'undefined') {
    const back = window.history.state?.back as string | null
    backButtonUrl.value = back && ['/active-rfqs', '/closed-rfqs'].includes(back) ? back : '/'
  }
}, { immediate: true })
</script>

<template>
  <NuxtLoadingIndicator />
  <NuxtLayout name="dashboard" container-layout="fluid">
    <!-- TODO: Extend dashboard layout with a prop to hide the sidebar instead of this workaround (ref: PR #6360 review) -->
    <template #sidebar>
      <div class="w-0 overflow-hidden" aria-hidden="true" />
    </template>
    <template #header>
      <div class="flex gap-2 items-center">
        <Button as-child variant="outline" size="sm">
          <NuxtLink :to="backButtonUrl">
            <ArrowLeftIcon aria-hidden="true" />
            Back to All RFQs
          </NuxtLink>
        </Button>
      </div>
    </template>
    <div class="flex flex-col flex-1 min-h-0">
      <!-- Horizontal tab navigation bar -->
      <div class="flex shrink-0 items-center justify-between border-b border-default px-5">
        <div class="flex items-center gap-2 py-3">
          <ProjectAvatar v-if="details" :src="details?.project.image" />
          <span v-if="details" class="font-semibold text-sm whitespace-nowrap">
            {{ details?.project.name }} RFQ
          </span>
        </div>
        <div class="flex items-center gap-6">
          <RfqTabsNav :rfq-id="rfqId" :status="details?.rfq?.status" :is-reopened-for-me="details?.rfq?.isReopenedForMe" :current-round="details?.rfq?.round" />
        </div>
        <Button size="sm" @click="preferencesOpen = true">
          See RFQ Details
        </Button>
      </div>
      <!-- Page content -->
      <div class="flex flex-1 flex-col min-h-0">
        <slot />
      </div>
    </div>
  </NuxtLayout>
  <RfqPreferencesPanel :rfq-id="rfqId" />
</template>
